import React from 'react'
import { isRichTextEmpty } from '../../../lib/richText'
import uniq from 'lodash/uniq'
import withStyles from 'constructicon/with-styles'
import styles from './styles'
import isBadgeAchieved from './isBadgeAchieved'

import Badge from './Badge'
import Grid from 'constructicon/grid'
import GridColumn from 'constructicon/grid-column'
import Heading from 'constructicon/heading'
import RichText from '../../ui/RichText'

const Badges = ({
  customSupporterPage,
  fundraisingPage,
  items,
  styles,
  title
}) => {
  const { fitness } = customSupporterPage
  const categories = uniq(items.map(item => item.category))

  return (
    <div>
      {!isRichTextEmpty(title) && (
        <RichText styles={styles.title}>
          {title}
        </RichText>
      )}
      {categories.map((category, x) => {
        const badges = items.filter(item => item.category === category)

        return (
          <div key={x}>
            {category && (
              <Heading size={1} spacing={{ t: 1, b: 0.5 }}>
                {category}
              </Heading>
            )}
            <Grid
              justify='flex-start'
              spacing={0.5}>
              {badges.map((badge, y) => (
                <GridColumn
                  key={y}
                  xs={6}
                  lg={3}>
                  <Badge
                    achieved={isBadgeAchieved(badge, fundraisingPage, fitness.goalUom)}
                    badge={badge}
                    fundraisingPage={fundraisingPage}
                  />
                </GridColumn>
              ))}
            </Grid>
          </div>
        )
      })}
    </div>
  )
}

export default withStyles(styles)(Badges)
